$(document).on('turbolinks:load', function () {
  sendRecaptcha('page_load');

  $('.google-recaptcha-form').one('submit', function (e) {
    e.preventDefault();
    var $form = $(this);
    grecaptcha.ready(function() {
      grecaptcha.execute(GLOBAL_VARIABLES.recaptchaSiteKey, {action: 'submit'}).then(function(token) {
        $form.prepend('<input name="recaptcha_token" type="hidden" value="' + token + '"/>')
        $form.submit();
      });
    });
  });

  $('a.conversion').on('click', function () {
    sendRecaptcha('conversion_click')
  });
});

function sendRecaptcha(actionName) {
  grecaptcha.ready(function () {
    grecaptcha.execute(GLOBAL_VARIABLES.recaptchaSiteKey, { action: actionName })
        .then(function (token) {
          fetch("/hd/recaptcha_results", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
            },
            body: JSON.stringify({
              token: token,
              recaptcha_action: actionName,
              location: window.location.href
            })
          });
        });
  });
}
